import React from 'react';
import { Pie } from 'react-chartjs-2';
import { FiltroSopInventory, RepositorioSopInventory } from '../../core/repositories/sopInventoryRepositorio';
import { ChartData } from 'chart.js';
import { useTranslation } from 'react-i18next';
import { useToast } from '../../core/contexts/toast';
import SopLoadingAnimation from '../../components/sopLoadingAnimation';
import { colorGraph, formatLargeNumber } from '../../core/utils/funcoes';

const SopInventoryRegionPieChart: React.FC<{ filtro: FiltroSopInventory }> = (props) => {


    const { mostrarToast } = useToast();
    const { t } = useTranslation();
    const [data, setData] = React.useState<ChartData<"pie">>({} as ChartData<"pie">);
    const [carregando, setCarregando] = React.useState(true);


    React.useEffect(() => {
        setCarregando(true);
        new RepositorioSopInventory().getShareRegion(props.filtro).then((res) => {
            setData({
                labels: ['Finished Goods', 'WIP', 'Raw Materials & Packaging', 'MRO'],
                datasets: [
                    {
                        label: 'Revenue Share',
                        data: (res.length > 0 ? [res[0].finished_goods, res[0].raw_material, res[0].work_in_progress, res[0].others_mro] : []),
                        backgroundColor: colorGraph(),
                        borderColor: '#fff',
                        borderWidth: 2,
                    }
                ]
            });
            setCarregando(false);
        }).catch((error) => {
            mostrarToast({
                titulo: t("pages.Erro!"),
                mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
                tipo: "error",
            });
        })
    }, [props.filtro]);



    // const data = {
    //     labels: ['Finished Goods', 'WIP', 'Raw Materials & Packaging', 'MRO', 'Auxiliary Materials',],

    //     datasets: [
    //         {
    //             label: 'Revenue Share',
    //             data: [18, 14, 26, 22],
    //             backgroundColor: [
    //                 '#4e73df',
    //                 '#1cc88a',
    //                 '#36b9cc',
    //                 '#f6c23e',
    //                 '#e74a3b',
    //                 '#858796',
    //             ],
    //             borderColor: '#fff',
    //             borderWidth: 2,
    //         },
    //     ],
    // };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'right' as const,
                labels: {
                    color: '#333',
                    font: {
                        size: 14,
                    },
                },
            },

            tooltip: {
                callbacks: {
                    label: function (context: any) {
                        const value = context.parsed;
                        return `${context.label}: ${formatLargeNumber(value)}`;
                    },
                },
            },
        },
    };

    return (
        // <div className="region-pie-chart">
        //     <div className="chart-container">

        //     </div>
        // </div>

        <div className="card p-3 shadow-sm border-0" style={{ height: '250px' }}>
            <strong className=" title-card">{props.filtro?.value !== "Quantity" ? 'Revenue' : 'Quantity'} Share by Class</strong>
            {carregando ?
                <SopLoadingAnimation type="PIE" />
                :
                <div>
                    <Pie data={data} options={options} />
                </div>
            }
        </div>

    );
};

export default SopInventoryRegionPieChart;
